import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  headerStyle: rest => ({
    height: 25,
    marginTop: 19,
    marginBottom: 10,
    marginHorizontal: 2,
    ...rest,
  }),
});
